(() => {
  const initializeSlider = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const slides = [...root.querySelectorAll('[data-slider-slide]')];
    if (!slides.length) return;

    root.dataset.initialized = 'true';

    const dots = [...root.querySelectorAll('[data-slider-dot]')];
    const viewport = root.querySelector('.responsive-slider__viewport');
    const previous = root.querySelector('[data-slider-previous]');
    const next = root.querySelector('[data-slider-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let activePointerId = null;
    let suppressClick = false;
    let hasAutoplayAdvanced = false;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (root.dataset.autoplay !== 'true' || reduceMotion || slides.length < 2) return;
      timer = window.setInterval(() => {
        showSlide(activeIndex + 1);
        hasAutoplayAdvanced = true;
        if (root.matches(':hover')) stopAutoplay();
      }, Number(root.dataset.speed) || 5000);
    };

    previous?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startAutoplay();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.sliderDot));
      startAutoplay();
    }));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    viewport?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      suppressClick = false;
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
      stopAutoplay();
    });

    viewport?.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) return;
      const distanceX = event.clientX - pointerStartX;
      const distanceY = event.clientY - pointerStartY;
      if (Math.abs(distanceX) > 8 && Math.abs(distanceX) > Math.abs(distanceY)) suppressClick = true;
    });

    const finishSwipe = (event) => {
      if (event.pointerId !== activePointerId) return;
      const distanceX = event.clientX - pointerStartX;
      const distanceY = event.clientY - pointerStartY;
      const swipeThreshold = Math.min(80, Math.max(35, viewport.clientWidth * 0.08));

      if (Math.abs(distanceX) >= swipeThreshold && Math.abs(distanceX) > Math.abs(distanceY)) {
        showSlide(activeIndex + (distanceX < 0 ? 1 : -1));
        suppressClick = true;
      }

      activePointerId = null;
      viewport.classList.remove('is-dragging');
      startAutoplay();
    };

    viewport?.addEventListener('pointerup', finishSwipe);
    viewport?.addEventListener('pointercancel', finishSwipe);
    viewport?.addEventListener('dragstart', (event) => event.preventDefault());
    viewport?.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    root.addEventListener('mouseenter', () => {
      if (hasAutoplayAdvanced) stopAutoplay();
    });
    root.addEventListener('mouseleave', () => {
      if (activePointerId === null) startAutoplay();
    });
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());

    showSlide(0);
    startAutoplay();
  };

  const initializeAllSliders = (scope = document) => {
    if (scope.matches?.('[data-responsive-slider]')) initializeSlider(scope);
    scope.querySelectorAll?.('[data-responsive-slider]').forEach(initializeSlider);
  };

  initializeAllSliders();
  document.addEventListener('shopify:section:load', (event) => initializeAllSliders(event.target));
})();
